export type DisplayRole = 'view-only' | 'admin' | 'super-admin';

interface NestedRole {
  role?: string | null;
}

export interface RoleListItem {
  role?: string | null;
  user?: {
    userCustomerRolesByUserId?: {
      nodes?: NestedRole[] | null;
    } | null;
  } | null;
}

/**
 * super-admin is global: once a user is made a super-admin in ANY workspace, they
 * should display (and act) as a super-admin in every workspace. The Team list query
 * is workspace-scoped, so a user's row for THIS workspace may say view-only/admin even
 * though they hold super-admin elsewhere. The nested userCustomerRolesByUserId
 * connection is unscoped and carries every workspace's role, so we check it first.
 */
export const computeDisplayRole = (listItem: RoleListItem): DisplayRole => {
  const isGlobalSuperAdmin = !!listItem?.user?.userCustomerRolesByUserId?.nodes?.some(
    (r) => r?.role === 'SUPER_ADMIN'
  );
  if (isGlobalSuperAdmin) {
    return 'super-admin';
  }
  const role = listItem?.role;
  return role === 'VIEW_ONLY' ? 'view-only' : role === 'ADMIN' ? 'admin' : 'super-admin';
};
